import axios from 'axios'
import { BUSCAR_CONFIG_GRATUIDADE_TIPO_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const CACHE_PREFIX = 'vexado_gratuidade_config_';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarConfigGratuidadeTipoPreco(empresaId) {
  const url = `${URL}/empresas/${empresaId}/gratuidade-tipo-preco-config`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      try { localStorage.setItem(`${CACHE_PREFIX}${empresaId}`, JSON.stringify(response.data)); } catch (_) { // ignore
      }
      return dispatch({ type: BUSCAR_CONFIG_GRATUIDADE_TIPO_PRECO, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        try {
          const cache = localStorage.getItem(`${CACHE_PREFIX}${empresaId}`);
          if (cache) return dispatch({ type: BUSCAR_CONFIG_GRATUIDADE_TIPO_PRECO, payload: { data: JSON.parse(cache) } });
        } catch (_) { // ignore
        }
      }
      throw erro;
    });
}
